import {
    BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS,
    BQ_CLICKED_CUSTOM_ORDER,
    BQ_CLICKED_CONTACT_SELLER
} from '../../../../utils/bigQueryEvents';
import {
    MP_CONTACT_SELLER_OPTIONS_CLICK,
    MP_CONTACT_SELLER_OPTIONS_CUSTOM_ORDER_CLICK,
    MP_CONTACT_SELLER_OPTIONS_CUSTOM_ORDER_SUBMIT,
    MP_CONTACT_SELLER_OPTIONS_CUSTOM_ORDER_CLOSE,
    MP_CONTACT_SELLER_OPTIONS_SEND_MESSAGE_SUBMIT_SUCCESS,
    MP_CONTACT_SELLER_OPTIONS_SEND_MESSAGE_CLICK
} from '../../../../utils/mixPanelEvents';

const eventSource = 'contact_seller_options';
const name = 'contact_seller';

export const reportPopoverClick = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_CLICK
    });

    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS
    });
};

export const reportSendMessageClick = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_SEND_MESSAGE_CLICK
    });

    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_CONTACT_SELLER,
        params: {
            name,
            eventSource
        }
    });
};

export const reportSendMessageSubmitSuccess = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_SEND_MESSAGE_SUBMIT_SUCCESS
    });
};

export const reportCustomOrderClick = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_CUSTOM_ORDER_CLICK
    });
    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_CUSTOM_ORDER,
        params: {
            eventSource
        }
    });
};

export const reportCustomOrderSubmitSuccess = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_CUSTOM_ORDER_SUBMIT
    });
};

export const reportCustomOrderClose = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_CUSTOM_ORDER_CLOSE
    });
};
